import {
  TKwikUIInputEmailCase,
  TKwikUIInputEmailSize,
  VKwikUIInputEmailCase,
  VKwikUIInputEmailSize
} from "./input-email.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const { isArray } = Array;
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    case: (x: TKwikUIInputEmailCase) => VKwikUIInputEmailCase.includes(x),
    disabled: isBoolean,
    domains: isArray,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    id: isString,
    invalid: isBoolean,
    label: isString,
    placeholder: isString,
    postfix: isString,
    prefix: isString,
    size: (x: TKwikUIInputEmailSize) => VKwikUIInputEmailSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
